import { generatePath, useNavigate } from 'react-router-dom';

import { tests } from 'us-react-components/dist/constants/Tests';
import { NotificationCard as SharedNotificationCard } from 'us-react-components/dist/NotificationCard/NotificationCard';
import { Notification } from 'us-web-services';

import { useDependencies } from '../../../dependencies';
import { Routes } from '../../../Routes';

interface Props {
  notification: Notification;
}

export const NotificationCard = ({ notification }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { stores: { user } } = useDependencies();

  const goToContext = (): void => {
    if (notification.backgroundCheckId || notification.userPlanId) {
      if (user.inTestGroup(tests.CAREGIVER_PAYWALL_STRIPE_PAYMENT)) {
        navigate(Routes.caregiver.buyBackgroundCheck);
      } else {
        navigate(Routes.backgroundCheckBuy);
      }
    } else if (notification.bookingId) {
      navigate(generatePath(Routes.bookings.id, { id: notification.bookingId.toString() }));
    } else if (notification.referredSitterId) {
      navigate(generatePath(Routes.sitter.profile, { id: notification.referredSitterId.toString() }));
    } else if (notification.parentIdToReview) {
      navigate(generatePath(Routes.parent.feedback, {
        id: notification.parentIdToReview.toString(),
      }));
    } else if (notification.jobId) {
      navigate(generatePath(Routes.job.id, { id: notification.jobId.toString() }));
    } else if (notification.target === 'payout-methods') {
      navigate(Routes.sitter.payout);
    } else {
      navigate(Routes.caregiver.dashboard);
    }
  };

  return (
    <SharedNotificationCard
      id={notification.id}
      unread={notification.read === false}
      label={notification.label}
      message={notification.message}
      senderPictureUrl={notification.sender?.pictureUrl}
      onSelect={goToContext}
    />
  );
};
